import _regeneratorRuntime from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.splice.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { baseHeaders } from 'util/axios-request';
import { utilCookies } from '@/util/cookies';
var baseURL = process.env.VUE_APP_BASE_API;
export default {
  props: {
    subProjectId: String,
    type: String // add 批量导入  update 批量修改
  },
  data: function data() {
    return {
      multiple: true,
      fileFormat: ['.xls', '.xlsx'],
      baseHeaders: baseHeaders(),
      fileSize: 5,
      uploadHeaders: {},
      successFileList: [],
      uploadStatus: false,
      uploadTotalCount: 0,
      // 总数
      uploadSuccessCount: 0,
      // 成功数
      uploadFailCount: 0,
      // 失败数
      update_count: 0,
      // 覆盖数
      feedbackFileUrl: '',
      form: {
        name: ''
      },
      formData: {
        sub_project_id: this.subProjectId
      }
    };
  },
  computed: {
    uploadUrl: function uploadUrl() {
      return this.type === 'add' ? baseURL + 'web/staff/importStaff' : baseURL + '/web/staff/importUpdateStaff';
    }
  },
  methods: {
    handleExport: function handleExport() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var lang, res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              // 模版下载
              lang = utilCookies.getLanguage() && utilCookies.getLanguage().substring(0, 2) || 'th';
              res = '';
              if (!(_this.type === 'update')) {
                _context.next = 14;
                break;
              }
              _context.t0 = lang;
              _context.next = _context.t0 === 'zh' ? 6 : _context.t0 === 'th' ? 8 : _context.t0 === 'en' ? 10 : _context.t0 === 'id' ? 12 : 14;
              break;
            case 6:
              res = 'https://ard-flashhr-pro.oss-ap-southeast-1.aliyuncs.com/file/StaffInfo-Edit-Zh-c4938f8df2d97e71a55690fe01475777.xlsx';
              return _context.abrupt("break", 14);
            case 8:
              res = 'https://ard-flashhr-pro.oss-ap-southeast-1.aliyuncs.com/file/StaffInfo-Edit-Th-771afb2cfe4e30836eb7e48f34d4b26d.xlsx';
              return _context.abrupt("break", 14);
            case 10:
              res = 'https://ard-flashhr-pro.oss-ap-southeast-1.aliyuncs.com/file/StaffInfo-Edit-En-39fd4d7ba4e81fb19ef91362be012c2f.xlsx';
              return _context.abrupt("break", 14);
            case 12:
              res = 'https://ard-flashhr-pro.oss-ap-southeast-1.aliyuncs.com/file/StaffInfo-Edit-Id-08b6e0ef9c1c8c729e1a69811b9cd740.xlsx';
              return _context.abrupt("break", 14);
            case 14:
              if (!(_this.type === 'add')) {
                _context.next = 26;
                break;
              }
              _context.t1 = lang;
              _context.next = _context.t1 === 'zh' ? 18 : _context.t1 === 'th' ? 20 : _context.t1 === 'en' ? 22 : _context.t1 === 'id' ? 24 : 26;
              break;
            case 18:
              res = 'https://ard-flashhr-pro.oss-ap-southeast-1.aliyuncs.com/file/StaffInfo-Add-Zh-5e9ff7af9eaeda2059c45880f999ca3d.xlsx';
              return _context.abrupt("break", 26);
            case 20:
              res = 'https://ard-flashhr-pro.oss-ap-southeast-1.aliyuncs.com/file/StaffInfo-Add-Th-fbb4ff5a68da2c92291f85745dd3ef88.xlsx';
              return _context.abrupt("break", 26);
            case 22:
              res = 'https://ard-flashhr-pro.oss-ap-southeast-1.aliyuncs.com/file/StaffInfo-Add-En-f94b479469f95f2fc8c60366a95b25b0.xlsx';
              return _context.abrupt("break", 26);
            case 24:
              res = 'https://ard-flashhr-pro.oss-ap-southeast-1.aliyuncs.com/file/StaffInfo-Add-Id-3803557c1b5e99a04d79c8a95f9f1cf5.xlsx';
              return _context.abrupt("break", 26);
            case 26:
              window.open(res);
            case 27:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    beforeUploadHandle: function beforeUploadHandle(file) {
      //  文件扩展名
      if (this.fileFormat.length) {
        var fileExtend = file.name.substring(file.name.lastIndexOf('.')).toLowerCase();
        if (this.fileFormat.indexOf(fileExtend) <= -1) {
          this.$message.error(this.$t('729', {
            fileFormat: this.fileFormat.join()
          }));
          return false;
        }
      }
      // 文件大小
      if (!(file.size / 1024 / 1024 < this.fileSize)) {
        this.$message.error(this.$t('730', {
          fileSize: this.fileSize
        }));
        return false;
      }
    },
    // 上传成功+
    successHandle: function successHandle(res, file) {
      var response = res;
      var data = response.data;
      if (response && response.code === 1) {
        this.uploadStatus = true;
        this.uploadSuccessCount = this.type === 'add' ? data.insert_count : data.success_count;
        this.uploadFailCount = data.error_count;
        this.update_count = data.update_count;
        this.feedbackFileUrl = res.data.down_load_excel.object_url;
        // window.open(res.data.down_load_excel.object_url)
        // if (data.upload_result_state === 1) {
        //   // 全部成功
        //   this.uploadTotalCount = data.upload_total_count
        //   this.$message.success(this.$t('935'))
        // } else if (data.upload_result_state === 5) {
        //   // 部分成功
        //   this.uploadTotalCount = data.upload_total_count
        //   this.uploadSuccessCount = data.insert_count
        //   this.uploadFailCount = data.error_count
        //   this.feedbackFileUrl = data.feedback_file_url
        //   this.$message.error(this.$t('936'))
        // } else if (data.upload_result_state === 3) {
        //   // 全部失败
        //   this.uploadTotalCount = data.upload_total_count
        //   this.uploadSuccessCount = data.insert_count
        //   this.uploadFailCount = data.upload_fail_count
        //   this.feedbackFileUrl = data.feedback_file_url
        //   this.$message.error(this.$t('937'))
        // }
      }
    },
    handleOpenUrl: function handleOpenUrl() {
      window.open(this.feedbackFileUrl);
    },
    // 上传失败
    // err, file, fileList
    errorHandle: function errorHandle(err, file) {
      var index = this.$refs.upload.uploadFiles.findIndex(function (v) {
        return v.name === file.name;
      });
      this.$refs.upload.uploadFiles.splice(index, 1);
      this.$message.error('upload error');
      throw err;
    },
    resetDate: function resetDate() {
      this.uploadTotalCount = 0; // 总数
      this.uploadSuccessCount = 0; // 成功数
      this.uploadFailCount = 0; // 失败数
      this.feedbackFileUrl = '';
      this.uploadStatus = false;
      this.update_count = 0;
    },
    // 弹窗关闭时
    closeHandle: function closeHandle() {
      this.reset();
      this.resetDate();
    },
    reset: function reset() {
      this.$refs.upload.clearFiles();
      this.successFileList = [];
    }
  },
  watch: {
    successFileList: {
      handler: function handler(val) {
        if (val.length) this.$emit('uploadSuccess', val);
      },
      deep: true
    }
  }
};